import {
  Flex,
  Text,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  UnorderedList,
  ListItem,
  Box,
} from '@chakra-ui/react';

import {RulesIcon2} from '../../icons/RulesIcon2';
import {useTranslate} from '@eksab/i18n';

export const WERulesModal = ({isOpen, onClose}: {isOpen: boolean; onClose: () => void}) => {
  const t = useTranslate();

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Flex gap="3">
            <RulesIcon2 />
            <Flex flexDir="column" justifyContent="space-between">
              <Text fontSize="small" color="#8f8f8f" fontWeight="semibold">
                {t('trivia.rules.check_before_playing')}
              </Text>
              <Text fontSize="2xl" fontWeight="bold">
                {t('trivia.rules.we.terms-and-conditions')}
              </Text>
            </Flex>
          </Flex>
        </ModalHeader>
        <ModalBody overflowY="scroll" maxH="600px">
          <Text mb={3}>{t('trivia.rules.we.terms-and-conditions.description')}</Text>
          <Text fontSize="2xl" fontWeight="bold" mb={3}>
            {t('trivia.rules.we.how-to-participate')}
          </Text>
          <Box mb={3}>
            <Text fontSize="xl" fontWeight="bold">
              {t('trivia.rules.we.game-details')}
            </Text>
            <UnorderedList>
              <ListItem>{t(`trivia.rules.we.game-details.1`)}</ListItem>
              <ListItem>{t(`trivia.rules.we.game-details.2`)}</ListItem>
              <ListItem>{t(`trivia.rules.we.game-details.3`)}</ListItem>
              <ListItem>{t(`trivia.rules.we.game-details.4`)}</ListItem>
              <ListItem>{t(`trivia.rules.we.game-details.5`)}</ListItem>
            </UnorderedList>
          </Box>
          <Box mb={3}>
            <Text fontSize="xl" fontWeight="bold">
              {t('trivia.rules.we.game-duration')}
            </Text>
            <UnorderedList>
              <ListItem>{t(`trivia.rules.we.game-duration.1`)}</ListItem>
            </UnorderedList>
          </Box>
          <Box>
            <Text fontSize="xl" fontWeight="bold">
              {t('trivia.rules.we.prize-details')}
            </Text>
            <UnorderedList>
              <ListItem>
                {t(`trivia.rules.we.prize-details.1`)}
                <UnorderedList>
                  <ListItem>{t(`trivia.rules.we.prize-details.1.1`)}</ListItem>
                  <ListItem>{t(`trivia.rules.we.prize-details.1.2`)}</ListItem>
                </UnorderedList>
              </ListItem>
              <ListItem>{t(`trivia.rules.we.prize-details.2`)}</ListItem>
              <ListItem>{t(`trivia.rules.we.prize-details.3`)}</ListItem>
            </UnorderedList>
          </Box>
        </ModalBody>
        <ModalCloseButton />
      </ModalContent>
    </Modal>
  );
};
